// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'
import { MonedaApiInputProps, MonedaProps } from '../interfaces'
import { FRAGMENT_MONEDA } from '../interfaces/fragment'

const query = gql`
  ${FRAGMENT_MONEDA}
  mutation MONEDA_ACTUALIZAR($id: ID!, $input: MonedaActualizarInputV2!) {
    monedaActualizarV2(id: $id, input: $input) {
      ...fields
    }
  }
`

/**
 * Actualizacion de datos de la moneda
 * @param id
 * @param input
 */
export const apiMonedaActualizar = async (
  id: string,
  input: MonedaApiInputProps,
): Promise<MonedaProps> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    // Set a single header
    client.setHeader('authorization', `Bearer ${token}`)

    const data: any = await client.request(query, { id, input })
    return data.monedaActualizarV2
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
